import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../api'
import SlipDoc from '../components/SlipDoc'

// Halaman CETAK standalone -- sengaja TIDAK dibungkus <Layout /> (tanpa sidebar/header app sama
// sekali), pola sama dgn PekerjaanListPublik.jsx dkk. Dibuka via window.open() dari tombol Cetak
// di Payroll.jsx, di TAB BARU yg isinya cuma slip ini -- jadi window.print() di sini otomatis cuma
// nyetak slip, TANPA perlu trik CSS "sembunyikan elemen lain" yg terbukti rapuh lintas browser
// (lihat komentar SlipDoc.jsx).
export default function PayrollSlipCetak() {
  const { id } = useParams()
  const [slip, setSlip] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    api.get(`/payroll/${id}`)
      .then(res => setSlip(res.data))
      .catch(e => setError(e.response?.data?.message || 'Gagal memuat slip'))
  }, [id])

  // Auto-print begitu konten sudah dirender -- delay kecil supaya browser sempat layout dulu
  // sebelum dialog print muncul (langsung print() di render pertama kadang menangkap layout kosong).
  useEffect(() => {
    if (!slip) return
    const t = setTimeout(() => window.print(), 400)
    return () => clearTimeout(t)
  }, [slip])

  if (error) return <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#b00' }}>{error}</div>
  if (!slip) return <div style={{ padding: 40, fontFamily: 'sans-serif' }}>Memuat...</div>

  return (
    <div style={{ maxWidth: 720, margin: '24px auto', padding: '0 20px' }}>
      <SlipDoc slip={slip} />
    </div>
  )
}
